// extracted by mini-css-extract-plugin
export default {"bgModal":"ConfirmationWindow_bgModal__gzy10","bg":"ConfirmationWindow_bg__rDEZP","modalBtns":"ConfirmationWindow_modalBtns__EvjHI"};